<div class="row mb-4">
  <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
    Event List
    <div class="border-green-bottom"></div>
  </div>
  <!-- <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end">
    <div class="search-area">
      <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
      <input type="text" class="search-input" placeholder="Search Menu" (keyup)="applyFilter($event)" />
    </div>
  </div> -->
  <div align="end" class="mt-2 mb-2">
    <button class="add-btn me-2 px-4 py-2" (click)="onCreateMenu()">Add Event</button>
  </div>
  <div class="table-responsive-scroll">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="EventName">
          <th mat-header-cell *matHeaderCellDef class="font-gray">EventName</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.EventName }}</td>
        </ng-container>

        <ng-container matColumnDef="EventType">
          <th mat-header-cell *matHeaderCellDef class="font-gray">EventType</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.EventType || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="StartDate">
          <th mat-header-cell *matHeaderCellDef class="font-gray">StartDate</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ (item.StartDate | date : "dd/MM/yyyy") || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="EndDate">
          <th mat-header-cell *matHeaderCellDef class="font-gray">EndDate</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ (item.EndDate | date : "dd/MM/yyyy") || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="RegistrationLastDate">
          <th mat-header-cell *matHeaderCellDef class="font-gray">RegistrationLastDate</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ (item.RegistrationLastDate | date : "dd/MM/yyyy") || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="Venue">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Venue</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.Venue || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="City">
          <th mat-header-cell *matHeaderCellDef class="font-gray">City</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.City || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="RegistrationFee">
          <th mat-header-cell *matHeaderCellDef class="font-gray">RegistrationFee</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.RegistrationFee || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="EventDescription">
          <th mat-header-cell *matHeaderCellDef class="font-gray">EventDescription</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.EventDescription || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="Applied Students">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Applied Students</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">{{ item.AppliedStudentCount || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Status</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <button [ngClass]="item.IsActive ? 'plan-status-btn px-3' : 'absent-btn py-1 px-3'">
              {{ item.IsActive ? "Active" : "Inactive" }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="Edit">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Edit</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div [innerHtml]="SVG_ICONS.EDIT_PENCIL() | sanitizer : 'html'" role="button" (click)="onEditMenu(item.EventID)"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="Add">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Register</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div [innerHtml]="SVG_ICONS.ADD_MEMBER_ICON() | sanitizer : 'html'" role="button" (click)="onRegisterMenu(item.EventID)"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="View">
          <th mat-header-cell *matHeaderCellDef class="font-gray">View</th>
          <td mat-cell *matCellDef="let item" class="font-white p-3">
            <div [innerHtml]="SVG_ICONS.EYE_ICON() | sanitizer : 'html'" role="button" (click)="onViewMenu(item.EventID)"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <!-- <mat-paginator [pageSizeOptions]="[10, 20]" [length]="length" showFirstLastButtons class="mt-3"></mat-paginator> -->
    </div>
  </div>
</div>
